import { FC, useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { Redirect, Route } from "react-router-dom";

import Login from './pages/authentication/Login'
import Register from './pages/authentication/Register'
import RegisterPendingReview from './pages/authentication/RegisterPendingReview'
import RegisterDomainExists from './pages/authentication/RegisterDomainExists'
import './utils/yupAugment'
import ActivateAccount from './pages/authentication/ActivateAccount';
import Dashboard from './pages/Dashboard';
import { CoreAdminUI, Resource, useAuthProvider } from 'ra-core';
import Layout from './pages/layout/Layout'
import ProfileCreate from './pages/profile/Create';
import OrganizationProfileCreate from './pages/settings/organization/OrganizationProfile/Create';
import OrganizationProfileUpdate from './pages/settings/organization/OrganizationProfile/Update';
import SsoConfig from './pages/settings/organization/SsoConfig/Update';
import DataAccessPolicy from './pages/settings/encryption/DataAccessPolicy/List'
import CatchAllUndefinedRoute from './components/CatchAllUndefinedRoute';
import ProfileUpdate from './pages/profile/Update';
import PasswordChange from './pages/authentication/PasswordChange';
import { OrganizationSettingsComposite } from './pages/settings/organization/OrganizationSettingsComposite';
import Users from './pages/settings/organization/Users/List';
import InvitationConfirm from './pages/authentication/InvitationConfirm';
import RegistrationOnlyResource from './components/RegistrationOnlyResource';
import SsoRedirect from './pages/authentication/SsoRedirect';
import PasswordRecovery from './pages/authentication/resetpassword/PasswordRecovery';
import PasswordRecoverySent from './pages/authentication/resetpassword/PasswordRecoverSent';
import ResetPasswordCollect from './pages/authentication/resetpassword/ResetPasswordCollect';
import OdResource from './components/recource/OdResource';
import BackupResourceRegister from './pages/backups/BackupResourceRegister';
import BackupValidationList from './pages/backups/BackupValidationList';
import BackupValidationDetail from './pages/backups/BackupValidationDetail';
import BackupValidationDashboard from './pages/backups/BackupValidationDashboard';
import { ContinuityComposite } from './pages/backups/ContinuityComposite';
import DatabaseDetail from './pages/databases/DatabaseDetail';
import SimpleComposite from './components/recource/SimpleComposite';
import DatabaseResourceRegister from './pages/databases/DatabaseResourceRegister';
import EncryptionDashboard from './pages/obfuscation/EncryptionDashboard';
import CreateCustomRule from './pages/obfuscation/CreateCustomRule';
import CustomRuleList from './pages/obfuscation/CustomRuleList';
import EditCustomRule from './pages/obfuscation/EditCustomRule';
import EditEncryptionMappings from './pages/obfuscation/EditEncryptionMappings';
import EncryptionDetail from './pages/obfuscation/EncryptionDetail';
import EncryptionList from './pages/obfuscation/EncryptionList';
import EncryptionMappings from './pages/obfuscation/EncryptionMappings';
import EncryptionDashboardResourceRegister from './pages/obfuscation/EncryptionDashboardResourceRegister';
import DeploymentDashboard from './pages/deployment/DeploymentDashboard';
import { DataCatalogComposite } from './pages/governance/DataCatalogComposite';
import GovernanceDashboard from './pages/governance/GovernanceDashboard';
import GovernanceResourceRegister from './pages/governance/GovernanceResourceRegister';
import DeploymentDetail from './pages/deployment/DeploymentDetail';
import DeploymentList from './pages/deployment/DeploymentList';
import CustomerAgreement from './components/authentication/CustomerAgreement';
import PrivacyNotice from './components/authentication/PrivacyNotice';
import DocumentsLanding from './pages/documents/DocumentsLanding';
import { DeploymentSettingsComposite } from './pages/deployment/DeploymentSettingsComposite'
import { DeploymentsComposite } from './pages/deployment/DeploymentsComposite';
import NetworkConfigurationList from './pages/deployment/NetworkConfigurationList';
import NetworkConnectionDetail from './pages/deployment/NetworkConnectionDetail';
import PerformanceTuningDashboard from './pages/performance/PerformanceTuningDashboard';
import SecureFileDashboard from './pages/securefiles/SecureFileDashboard';
import OwnershipStatisPage from './pages/securefiles/OwnershipStatisPage';
import SecureFileDetail from './pages/securefiles/FileDetail';
import SecureFileCatalog from './pages/securefiles/FileCatalog';
import SecureFileAccessLogs from './pages/securefiles/FileAccessLogs';
import SecureFilesResourceRegister from './pages/securefiles/SecureFilesResourceRegister';
import DataClassifications from './pages/settings/governance/DataClassifications';
import DataAccessRoleList from './pages/settings/governance/DataAccessRoleList';
import DataAccessRoleDetail from './pages/settings/governance/DataAccessRoleDetail';
import CreateDataAccessRole from './pages/settings/governance/CreateDataAccessRole';
import DataCatalog from './pages/governance/DataCatalog';
import DatabaseKeysPolicy from './pages/databases/DatabaseKeysPolicy';
import NotificationSettings from './pages/settings/notification/NotificationSettings';
import { EncryptionSettingsComposite } from './pages/settings/encryption/EncryptionSettingsComposite';
import { GovernanceSettingsComposite } from './pages/settings/governance/GovernanceSettingsComposite';
import { ProductsReleaseComposite } from './pages/release/ProductsReleaseComposite';
import UpdateEncryptionMappings from './pages/obfuscation/UpdateEncryptionMappings';
import EncryptionMappingsResourceRegister from './pages/obfuscation/EncryptionMappingsResourceRegister';
import DataOwnerGroupList from './pages/settings/governance/DataOwnerGroupList';
import DataOwnership from './pages/governance/DataOwnership';
import EditTablesOwnership from './pages/governance/EditTablesOwnership';
import DatabaseSemanticDetail from './pages/governance/DatabaseSemanticDetail';
import TableFieldsPage from './pages/governance/TableFieldsPage';
import CloudSubscriptionUpdate from './pages/settings/organization/CloudSubscription/Update';
import ObfuscationRuleList from './pages/settings/encryption/ObfuscationRule/ObfuscationRuleList';
import ObfuscationMappingList from './pages/obfuscation/ObfuscationMappingList';
import EditObfuscationMappings from './pages/obfuscation/EditObfuscationMappings';
import ObfuscationDetail from './pages/obfuscation/ObfuscationDetail';
import ObfuscationList from './pages/obfuscation/ObfuscationList';
import Device from './pages/authentication/Device';
import DeviceConsent from './pages/authentication/DeviceConsent';
import ClientManage from './pages/settings/organization/Clients/List';
import IpWhitelist from './pages/settings/organization/IpWhitelist/List';
import DatabaseEncryptionSettingChange from './pages/databases/DatabaseEncryptionSettingChange';
import FileTemplateDetail from './pages/obfuscation/FileTemplateDetail';
import { EncryptionComposite } from './pages/obfuscation/EncryptionComposite';
import KeyContent from './pages/settings/encryption/keys/KeyContent';
import DbSubsettingDetail from './components/obfuscation/DbSubsettingDetail';
import { Permissions_new } from './constants';
import { getSettingsMenuDefaultRoute } from './authProvider/permissionMap';
import { SecureFileComposite } from './pages/securefiles/SecureFileComposite';
import OfflineFileSearch from './pages/securefiles/OfflineFileSearch';
import ClassificationRules from './pages/settings/securefile/ClassificationRules';
import CreateClassificationRule from './pages/settings/securefile/CreateClassificationRule';
import DataProtectionRules from './pages/settings/securefile/DataProtectionRules';
import CreateDataProtectionRule from './pages/settings/securefile/CreateDataProtectionRule';
import { SecureFileSettingsComposite } from './pages/settings/securefile/SecureFileSettings';
import BasicSettings from './pages/settings/securefile/BasicSettings';
import CustomKeyVaultSettings from './pages/settings/securefile/CustomKeyVaultSettings';
import SecureFilePerClientSetting from './pages/settings/securefile/SecureFilePerClientSetting';
import EncryptionToolRelease from './pages/release/encryptiontool/EncryptionToolRelease';
import SecureFileRelease from './pages/release/securefile/SecureFileRelease';
import OnDataJdbcRelease from './pages/release/jdbc/OnDataJdbcRelease';
import OnDataOdbcRelease from './pages/release/odbc/OnDataOdbcRelease';
import OnDataSqlClientRelease from './pages/release/sqlclient/OnDataSqlClientRelease';
import DatabaseAssignClients from './pages/obfuscation/DatabaseAssignClients';
import FileTemplateAssignClients from './pages/obfuscation/FileTemplateAssignClients';
import InfoTypeList from './pages/settings/securefile/InfoTypeList';
import CreateInfoType from './pages/settings/securefile/CreateInfoType';
import EditInfoType from './pages/settings/securefile/EditInfoType';
import DocumentTypeList from './pages/settings/securefile/DocumentTypeList';
import CreateDocumentType from './pages/settings/securefile/CreateDocumentType';
import EditDocumentType from './pages/settings/securefile/EditDocumentType';
import AutoDiscoverySettings from './pages/settings/securefile/AutoDiscoverySettings';
import LegalWarningSettings from './pages/settings/securefile/LegalWarningSettings';
import OnpremisesDataAnalyzerSettings from './pages/settings/securefile/OnpremisesDataAnalyzerSettings';
import ClassificationProtectionSettings from './pages/settings/securefile/ClassificationProtectionSettings';
import DatabaseClassificationProtectionSettings from './pages/settings/encryption/DatabaseClassificationProtection/DatabaseClassificationProtectionSettings';
import DataClassificationRules from './pages/settings/encryption/DatabaseClassificationProtection/DataClassificationRules';
import DbDataProtectionRules from './pages/settings/encryption/DatabaseClassificationProtection/DbDataProtectionRules';
import DataInfoTypes from './pages/settings/encryption/DatabaseClassificationProtection/DataInfoTypes';
import CreateDataInfoType from './pages/settings/encryption/DatabaseClassificationProtection/CreateDataInfoType';
import EditDataInfoType from './pages/settings/encryption/DatabaseClassificationProtection/EditDataInfoType';
import CreateDataClassificationRule from './pages/settings/encryption/DatabaseClassificationProtection/CreateDataClassificationRule';
import DataManagerReports from './pages/securefiles/DataManagerReports';
import PlainFileScanDetail from './pages/securefiles/PlainFileScanDetail';
import DMReportRefFiles from './pages/securefiles/DMReportRefFiles';
import DMRootFolderScanInfo from './pages/securefiles/DMRootFolderScanInfo';
import SecureAIComposite from './pages/secureai/SecureAIComposite';
import SecureAIDashboard from './pages/secureai/SecureAIDashboard';
import { SecureAISettingsComposite } from './pages/settings/secureai/SecureAISettingsComposit';
import SecureAIAppSetting from './pages/settings/secureai/SecureAIAppSetting';
import SecureAIAppDataSourceRegistratonCode from './pages/settings/secureai/MCPServersSetting';
import MCPServerDetail from './pages/secureai/MCPServerDetail';
import SecAiEditInfoType from './pages/settings/secureai/EditInfoType';
import SecAiCreateInfoType from './pages/settings/secureai/CreateInfoType';
import SecAiInfoTypeList from './pages/settings/secureai/InfoTypeList';
import SecureAIAppDetail from './pages/secureai/SecureAIAppDetail';


const withNoLayout: any = { noLayout: true }

const customRouts = [
  <Route path="/register" component={Register} {...withNoLayout} />,
  <Route path="/register-success" component={RegisterPendingReview} {...withNoLayout} />,
  <Route path="/register-domain-exists" component={RegisterDomainExists} {...withNoLayout} />,
  <Route path="/register-confirm" component={ActivateAccount} {...withNoLayout} />,
  <Route path="/invitation-confirm" component={InvitationConfirm} {...withNoLayout} />,
  <Route path="/sso-redirect" component={SsoRedirect} {...withNoLayout} />,
  <Route path="/change-password" component={PasswordChange} />,
  <Route path="/reset-password" component={PasswordRecovery} {...withNoLayout} />,
  <Route path="/reset-password-sent" component={PasswordRecoverySent} {...withNoLayout} />,
  <Route path="/reset-password-confirm" component={ResetPasswordCollect} {...withNoLayout} />,
  <Route path="/customer-agreement" component={CustomerAgreement} {...withNoLayout} />,
  <Route path="/privacy-notice" component={PrivacyNotice} {...withNoLayout} />,
  <Route path="/device" component={Device} {...withNoLayout} />,
  <Route path="/device-consent" component={DeviceConsent} {...withNoLayout} />,

  <Route path="/documents" component={DocumentsLanding} />,
  <Route path="/dashboard" component={() => <Redirect to="/" />} />,
]
const headBreadcrumbs = [{label:'Dashboard', path:'/dashboard'}]

const AppRoutes: FC = () => {
  const authProvider = useAuthProvider()
  const [permissions, setPermissions] = useState(new Set() as Set<Permissions_new>)
  useEffect(() => {
    (async () => {
      const permissions_1: Permissions_new[] = await authProvider.getPermissions(0)
      setPermissions(ps => {
        return (ps.size === 0 && permissions_1.length > 0 
          ? new Set(permissions_1) : ps)
      })
    })();
    authProvider.userManager.events.addUserLoaded(async () => {
      const permissions_1: Permissions_new[] = await authProvider.getPermissions(0)
      setPermissions(ps => {
        if (JSON.stringify([...ps]) !== JSON.stringify(permissions_1)) {
          return new Set(permissions_1)
        } else {
          return ps
        }
      })
    })
  }, [authProvider])


  return useMemo(() => { return (
    <CoreAdminUI
      catchAll={CatchAllUndefinedRoute}
      customRoutes={customRouts}
      disableTelemetry={true}
      layout={Layout}
      loginPage={Login}
      dashboard={Dashboard}
    >
      <RegistrationOnlyResource name="_registration_only_" />
      <Resource name="profile" options={{label:'User Profile', breadcrumbs:headBreadcrumbs}}
        create={ProfileCreate}
        edit={ProfileUpdate}
      />
      <OrganizationSettingsComposite name="settings/organization" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}}
        fallbackTo={getSettingsMenuDefaultRoute("Organization", permissions) ?? "/settings/organization/profile/edit"}
      >
        <Resource name="settings/organization/profile" 
          options={{
            label: 'Organization Profile',
            breadcrumbs: headBreadcrumbs,
            primaryPath: '/settings/organization/profile/edit',
          }} 
          create={OrganizationProfileCreate}
          edit={OrganizationProfileUpdate}
        />
        <Resource name="settings/organization/user-manage" options={{label: 'Users' , breadcrumbs:headBreadcrumbs}} 
          list={Users}
        />
        <Resource name="settings/organization/clients" options={{label: 'Clients' , breadcrumbs:headBreadcrumbs}} 
          list={ClientManage}
        />
        <Resource name="settings/organization/sso-config" options={{label: 'SSO Configuration' , breadcrumbs:headBreadcrumbs}} 
          list={SsoConfig}
        />
        <Resource name="settings/organization/cloud-subscription" options={{label: 'Cloud Subscription' , breadcrumbs:headBreadcrumbs}} 
          list={CloudSubscriptionUpdate}
        />
        <Resource name="settings/organization/ip-whitelist" options={{label: 'IP Whitelist' , breadcrumbs:headBreadcrumbs}} 
          list={IpWhitelist}
        />
      </OrganizationSettingsComposite>
      <Resource name="settings/notification" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}} 
        list={NotificationSettings}
      />
      <SecureFileSettingsComposite name="settings/securefile" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}}
        fallbackTo={getSettingsMenuDefaultRoute("SecureFileSettings", permissions) ?? "/settings/securefile/basic"}
      >
        <Resource name="settings/securefile/basic" options={{label: 'Basic' , breadcrumbs:headBreadcrumbs}} 
          list={BasicSettings}
        />
        <Resource name="settings/securefile/classification-n-protection" options={{label: 'Basic' , breadcrumbs:headBreadcrumbs}} 
          list={ClassificationProtectionSettings}
        />
        <Resource name="settings/securefile/auto-discovery" options={{label: 'Basic' , breadcrumbs:headBreadcrumbs}} 
          list={AutoDiscoverySettings}
        />
        <Resource name="settings/securefile/legal-warning" options={{label: 'Basic' , breadcrumbs:headBreadcrumbs}} 
          list={LegalWarningSettings}
        />
        <Resource name="settings/securefile/customkeyvault" options={{label: 'Basic' , breadcrumbs:headBreadcrumbs}} 
          list={CustomKeyVaultSettings}
        />
        <Resource name="settings/securefile/per-client-setting" options={{label: 'Basic' , breadcrumbs:[...headBreadcrumbs, {label:'SecureFile Settings', path:'/settings/securefile/auto-discovery'}]}} 
          list={SecureFilePerClientSetting}
        />
        <Resource name="settings/securefile/internal-data-analyzer" options={{label: 'Basic' , breadcrumbs:[...headBreadcrumbs, {label:'SecureFile Settings', path:'/settings/securefile/auto-discovery'}]}} 
          list={OnpremisesDataAnalyzerSettings}
        />
        <Resource name="settings/securefile/classification-rules" 
          options={{label: 'Basic' , breadcrumbs:[...headBreadcrumbs, {label:'SecureFile Settings', path:'/settings/securefile/classification-n-protection'}]}} 
          create={CreateClassificationRule}
          list={ClassificationRules}
          />
        <Resource name="settings/securefile/data-protection-rules" 
          options={{label: 'Basic' , breadcrumbs:[...headBreadcrumbs, {label:'SecureFile Settings', path:'/settings/securefile/classification-n-protection'}]}} 
          create={CreateDataProtectionRule}
          list={DataProtectionRules}
          />
        <Resource name="settings/securefile/info-types" 
          options={{label: 'Basic' , breadcrumbs:[...headBreadcrumbs, {label:'SecureFile Settings', path:'/settings/securefile/classification-n-protection'}]}} 
          edit={EditInfoType as any}
          create={CreateInfoType}
          list={InfoTypeList}
          />
        <Resource name="settings/securefile/document-types" 
          options={{label: 'Basic' , breadcrumbs:[...headBreadcrumbs, {label:'SecureFile Settings', path:'/settings/securefile/classification-n-protection'}]}} 
          edit={EditDocumentType as any}
          create={CreateDocumentType}
          list={DocumentTypeList}
          />
      </SecureFileSettingsComposite>
      <SecureAISettingsComposite name="settings/secureai" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}}
        fallbackTo={getSettingsMenuDefaultRoute("SecureAISettings", permissions) ?? "/settings/secureai/images"}
      >
        <Resource name="settings/secureai/images" options={{label: 'Images' , headBreadcrumbs}} 
          list={SecureAIAppSetting}
        />
        <Resource name="settings/secureai/registration-code" options={{label: 'Registration Code' , headBreadcrumbs}} 
          list={SecureAIAppDataSourceRegistratonCode}
        />
        <Resource name="settings/secureai/info-types" 
          options={{label: 'Basic' , breadcrumbs:[...headBreadcrumbs, {label:'Info Types', path:'/settings/secureai/info-types'}]}} 
          edit={SecAiEditInfoType as any}
          create={SecAiCreateInfoType}
          list={SecAiInfoTypeList}
        />
      </SecureAISettingsComposite>
      <EncryptionSettingsComposite name="settings/encryption" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}} 
        fallbackTo={getSettingsMenuDefaultRoute("Encryption", permissions) ?? "/settings/encryption/keys"}
      >
        <Resource name="settings/encryption/keys"
          options={{ label: 'Keys', breadcrumbs: headBreadcrumbs, }}
          list={KeyContent}
        />
        <Resource name="settings/encryption/tokens" 
          options={{label: 'Tokens' , breadcrumbs:headBreadcrumbs}} 
          list={DataAccessPolicy}
        />
        <Resource name="settings/encryption/obfuscation-rule"
          options={{ label: 'Obfuscation Rules', breadcrumbs: headBreadcrumbs, }}
          list={ObfuscationRuleList}
        />
        <Resource name="settings/encryption/classification-n-protection"
          options={{ label: 'Classification and Protection', breadcrumbs: headBreadcrumbs, }}
          list={DatabaseClassificationProtectionSettings}
        />
        <Resource name="settings/encryption/classification-rules"
          options={{ label: 'Data Classification Rules', breadcrumbs: headBreadcrumbs, }}
          create={CreateDataClassificationRule}
          list={DataClassificationRules}
        />
        <Resource name="settings/encryption/data-protection-rules"
          options={{ label: 'Data Protection Rules', breadcrumbs: headBreadcrumbs, }}
          list={DbDataProtectionRules}
        />
        <Resource name="settings/encryption/info-types"
          options={{ label: 'Data Info Types', breadcrumbs: headBreadcrumbs, }}
          create={CreateDataInfoType}
          edit={EditDataInfoType as any}
          list={DataInfoTypes}
        />
      </EncryptionSettingsComposite>
      <ProductsReleaseComposite name='release' options={{label: 'Releases' , breadcrumbs:headBreadcrumbs}} fallbackTo='/release/encryptiontool'>
        <Resource name="release/encryptiontool"
          options={{ label: 'Encryption Tool', breadcrumbs: headBreadcrumbs, }}
          list={EncryptionToolRelease}
        />
        <Resource name="release/securefile"
          options={{ label: 'SecureFile', breadcrumbs: headBreadcrumbs, }}
          list={SecureFileRelease}
        />
        <Resource name="release/jdbc"
          options={{ label: 'OnData JDBC', breadcrumbs: headBreadcrumbs, }}
          list={OnDataJdbcRelease}
        />
        <Resource name="release/odbc"
          options={{ label: 'OnData ODBC', breadcrumbs: headBreadcrumbs, }}
          list={OnDataOdbcRelease}
        />
        <Resource name="release/sqlclient"
          options={{ label: 'OnData SqlClient', breadcrumbs: headBreadcrumbs, }}
          list={OnDataSqlClientRelease}
        />
      </ProductsReleaseComposite>
      <GovernanceSettingsComposite name="settings/governance" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}} 
        fallbackTo={getSettingsMenuDefaultRoute("Data Access Policy", permissions) ?? '/settings/governance/data-classification'}
      >
        <Resource name="settings/governance/data-classification"
          options={{ label: 'Data Classifications' }}
          list={DataClassifications}
        />
        <Resource name="settings/governance/data-access-role"
          options={{
            label: 'Data Access Roles',
          }}
          list={DataAccessRoleList}
          show={DataAccessRoleDetail}
          create={CreateDataAccessRole}
        />
        <Resource name="settings/governance/data-owner-group"
          options={{ label: 'Data Owner Groups' }}
          list={DataOwnerGroupList}
        />
      </GovernanceSettingsComposite>
      <DeploymentSettingsComposite name="settings/deployment" fallbackTo="/settings/deployment/network-configuration">
        <Resource name="settings/deployment/network-configuration"
          options={{
            label: 'Network Configuration',
            breadcrumbs: headBreadcrumbs,
          }}
          list={NetworkConfigurationList}
          show={NetworkConnectionDetail}
        />
      </DeploymentSettingsComposite>
      <Resource name="settings"
        list={() => <Redirect to="/settings/organization/profile/edit" />}
      />

      <ContinuityComposite name="backups-n-validations" fallbackTo="/backups-n-validations/dashboard">
        <OdResource name="backups-n-validations/list" 
          options={{
            label: 'Backups and Validations', 
            breadcrumbs: [
              { label: 'Data Continuity Dashboard', path: '/backups-n-validations' }
            ],
          }} 
          resourceRegister={BackupResourceRegister}
          list={BackupValidationList}
          show={BackupValidationDetail}
        />
        <Resource name="backups-n-validations/dashboard" options={{label: 'Backups and Validations'}} 
          list={BackupValidationDashboard}
        />
      </ContinuityComposite>

      <SimpleComposite name="databases" fallbackTo="/dashboard">
        <Resource name="databases/:id/keys-policy"
          options={{
            label: 'Data Access Policy', 
            breadcrumbs: headBreadcrumbs,
          }} 
          list={DatabaseKeysPolicy}
        />
        <Resource name="databases/:id/encryption-setting-change"
          options={{
            label: 'Encryption Setting Change', 
            breadcrumbs: headBreadcrumbs,
          }} 
          list={DatabaseEncryptionSettingChange}
        />
        <OdResource name="databases" 
          options={{
            label: 'Database', 
            breadcrumbs: headBreadcrumbs,
          }} 
          resourceRegister={DatabaseResourceRegister}
          show={DatabaseDetail}
          list={Box}
        />
      </SimpleComposite>
      
      <EncryptionComposite name="encryption" fallbackTo="/encryption/dashboard">
        <Resource name="encryption/mappings/:dbId/update" 
          options={{
            label: 'Encryption Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          list={UpdateEncryptionMappings}
        />
        <Resource name="encryption/mappings/:dbId/clients" 
          options={{
            label: 'Encryption Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          list={DatabaseAssignClients}
        />
        <OdResource name="encryption/mappings" 
          options={{
            label: 'Encryption Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          resourceRegister={EncryptionMappingsResourceRegister}
          edit={EditEncryptionMappings as any}
          list={EncryptionMappings}
        />
        <Resource name="encryption/file-mappings/:tmplId/clients" 
          options={{
            label: 'Encryption Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          list={FileTemplateAssignClients}
        />
        <Resource name="encryption/file-mappings" 
          options={{
            label: 'Encryption Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          show={FileTemplateDetail as any}
          list={() => <Redirect to="/encryption/mappings" />}
        />
        <Resource name="encryption/obfs/mappings" 
          options={{
            label: 'Obfuscation Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          edit={EditObfuscationMappings as any}
          list={ObfuscationMappingList}
        />
        <Resource name="encryption/obfs/list"
          options={{
            label: 'Database Obfuscations',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          show={ObfuscationDetail}
          list={ObfuscationList}
        />
        <Resource name="encryption/list"
          options={{
            label: 'Database Encryptions',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          show={EncryptionDetail}
          list={EncryptionList}
        />
        <Resource name="encryption/subsetting/mastertables"
          options={{
            label: 'Database Encryptions',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          show={DbSubsettingDetail}
          list={() => <Redirect to="/encryption/dashboard" />}
        />
        <Resource name="encryption/custom-rules"
          create={CreateCustomRule}
          edit={EditCustomRule}
          list={CustomRuleList}
        />
        <OdResource name="encryption/dashboard"
          resourceRegister={EncryptionDashboardResourceRegister}
          list={EncryptionDashboard}
        />
      </EncryptionComposite>

      <DeploymentsComposite name="deployments" fallbackTo="/deployments/dashboard">
        <Resource name="deployments/list"
          options={{
            label: 'Database Deployments',
            breadcrumbs: [
              { label: 'Deployment Dashboard', path: '/deployments/dashboard' }
            ],
          }}
          list={DeploymentList}
          show={DeploymentDetail}
        />
        <Resource name="deployments/dashboard"
          list={DeploymentDashboard}
        />
      </DeploymentsComposite>

      <DataCatalogComposite name="governance" fallbackTo="/governance/dashboard">
        <OdResource name="governance/dashboard"
          resourceRegister={GovernanceResourceRegister}
          list={GovernanceDashboard}
        />
        <Resource name="governance/data-catalog" 
          options={{
            label: 'Data Catalog',
            breadcrumbs: [
              { label: 'Data Catalog Dashboard', path: '/governance/dashboard' }
            ],
          }}
          list={DataCatalog}
        />
        <Resource name="governance/data-ownership" 
          options={{
            label: 'Data Ownership',
            breadcrumbs: [
              { label: 'Data Catalog Dashboard', path: '/governance/dashboard' }
            ],
          }}
          list={DataOwnership}
          show={EditTablesOwnership}
        />
        <Resource name="governance/database-semantic/:dbId/table-fields"
          options={{
            label: 'Table Fields',
            breadcrumbs: [
              { label: 'Data Catalog Dashboard', path: '/governance/dashboard' }
            ],
          }}
          edit={TableFieldsPage}
          list={() => <Redirect to="/governance/dashboard" />}
        />
        <Resource name="governance/database-semantic"
          options={{
            label: 'Database Semantic',
            breadcrumbs: [
              { label: 'Data Catalog Dashboard', path: '/governance/dashboard' }
            ],
          }}
          edit={DatabaseSemanticDetail}
          list={() => <Redirect to="/governance/dashboard" />}
        />
      </DataCatalogComposite>
      
      <SecureFileComposite name="secure-files" fallbackTo="/secure-files/dashboard">
        <OdResource name="secure-files/dashboard"
          resourceRegister={SecureFilesResourceRegister}
          list={SecureFileDashboard}
        />
        <Resource name="secure-files/file-catalog" 
          options={{
            label: 'File Catalog',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={SecureFileCatalog}
        />
        <Resource name="secure-files/file-access-log" 
          options={{
            label: 'File Access Logs',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={SecureFileAccessLogs}
          />
        <Resource name="secure-files/offline-files" 
          options={{
            label: 'Offline Files',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={OfflineFileSearch}
          />
        <Resource name="secure-files/data-manager-reports/file-refs" 
          options={{
            label: 'Data Manager Reports',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={DMReportRefFiles}
          />
        <Resource name="secure-files/data-manager-reports" 
          options={{
            label: 'Data Manager Reports',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={DataManagerReports}
          />
        <Resource name="secure-files/ownership-statis" options={{
            label: 'Ownership Statistics',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }} list={OwnershipStatisPage} />
        <Resource name="secure-files/pfs"
          options={{
            label: 'File Catalog',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={() => <Redirect to={{pathname: "/secure-files/file-catalog", state: 'pfs'}} />}
          show={PlainFileScanDetail}
        />
        <Resource name="secure-files/clients/:clientId/dm-scan-info"
          options={{
            label: 'DataManager Root Folder Scan Info',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={DMRootFolderScanInfo}
        />
        <Resource name="secure-files"
          options={{
            label: 'File Access Logs',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={() => <Redirect to="/secure-files/dashboard" />}
          show={SecureFileDetail}
        />
      </SecureFileComposite>
        
      <SecureAIComposite name="secure-ai">
        <Resource name="secure-ai/dashboard"
          list={SecureAIDashboard}
        />
        <Resource name="secure-ai/app"
          options={{
            label: 'SecureAI Apps',
            breadcrumbs: [
              { label: 'SecureAI Dashboard', path: '/secure-ai/dashboard' }
            ],
          }}
          list={() => <Redirect to="/secure-ai/dashboard" />}
          show={SecureAIAppDetail}
        />
        <Resource name="secure-ai/mcp-servers"
          options={{
            label: 'MCP Servers',
            breadcrumbs: [
              { label: 'SecureAI Dashboard', path: '/secure-ai/dashboard' }
            ],
          }}
          list={() => <Redirect to="/secure-ai/dashboard" />}
          show={MCPServerDetail}
        />
        <Resource name="secure-ai"
          list={() => <Redirect to="/secure-ai/dashboard" />}
        />
      </SecureAIComposite>

      <SimpleComposite name="performance-tuning" fallbackTo="/performance-tuning/dashboard">
        <Resource name="performance-tuning/dashboard"
          list={PerformanceTuningDashboard}
        />
      </SimpleComposite>
    </CoreAdminUI>)
  }, [permissions]);
};


export default AppRoutes;
